import { render } from "./DeviceSoftwareComponent.vue?vue&type=template&id=a3a4ea8c"
import script from "./DeviceSoftwareComponent.vue?vue&type=script&lang=js"
export * from "./DeviceSoftwareComponent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/dmitriy-pc/Projects/docs.d-services.ru/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__